/**
 * A pay-later reservation with nothing paid on it yet (1NOW-11198, 1NOW-11476). Its booking page shows the whole
 * booking (trip, invoice, agreement, renter) with Pay and book on top, but none of the actions: no ID or insurance
 * verification, no uploads, no Edit or Cancel Booking, no other bookings. Once it is paid (or partly paid) the whole
 * page is back.
 *
 * Read from the booking itself, not from the way the renter got to the page (an email link, the pay-later policies
 * page, a booking card): a pay-now booking, a paid one and a partly paid one are not this. The same rule as the
 * Template's reservationUnpaid. A booking with `main_booking_uuid` set is a later cycle of a long-term stay, not
 * the reservation, so a renter mid-stay keeps the whole page.
 */
export const reservationUnpaid = (booking: any): boolean =>
  booking?.pay_later === true &&
  booking?.payment_status === "un-paid" &&
  !booking?.main_booking_uuid;

/** A money field as a number, or null when the booking does not carry it. */
const amount = (v: any): number | null => {
  if (v == null || v === "") return null;
  const n = Number(v);
  return Number.isFinite(n) ? n : null;
};

/** What the renter owes: the rental charge after any coupon, never the refundable deposit. Null when not carried. */
export const amountDue = (booking: any): number | null =>
  amount(booking?.invoice?.total_price_after_coupon_without_security) ??
  amount(booking?.invoice?.total_price_without_security) ??
  amount(booking?.final_price_without_security);
